// Никоси — active: «1 раз за матч: нанеси урон вражескому юниту = текущее Влияние».
// Влияние НЕ сжигается (по xlsx нет указания на сжигание).

import { applyDamage } from '../../combat.js';

export const HERO_ID = 'deus_nikosi';

export function nikosiActiveAvailable(state, playerIdx) {
  const p = state.players[playerIdx];
  if (!p || p.hero.id !== HERO_ID) return false;
  if (p.heroActiveUsed) return false;
  if (p.influence <= 0) return false;
  return true;
}

// targetCard — вражеский юнит (Card). Возвращает {ok, dmg, killed} или {ok:false, reason}.
export function nikosiActive(state, playerIdx, targetCard) {
  if (!nikosiActiveAvailable(state, playerIdx)) {
    return { ok: false, reason: 'unavailable' };
  }
  if (!targetCard || targetCard.type !== 'unit' || !targetCard.isAlive()) {
    return { ok: false, reason: 'invalid_target' };
  }
  const enemy = state.players[1 - playerIdx];
  if (!enemy.unitsOnField().includes(targetCard)) {
    return { ok: false, reason: 'not_enemy_unit' };
  }
  const p = state.players[playerIdx];
  const dmg = p.influence;
  const r = applyDamage(targetCard, dmg, { pierce: false });
  p.heroActiveUsed = true;
  state.log.add(`✨ Никоси [${p.name}] [active] → ${targetCard.name_ru} [${enemy.name}]: ${dmg} урона`);
  let killed = false;
  if (targetCard.hp <= 0) {
    enemy.removeFromField(targetCard);
    state.log.add(`✗ ${targetCard.name_ru} [${enemy.name}] погибает`);
    killed = true;
  }
  return { ok: true, dmg, killed, hpLost: r.hpLost, armorAbsorbed: r.armorAbsorbed };
}
